var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
// import { lazy } from "react";
// antd icons
import IconWrapper from "@ant-design/icons";
import * as Icons from "./Icons";
import "./Icon.css";
import { AntdIcons } from "./Icons.static";
/**
 * TE Icon Library.
 * You can use Antd Icons using the `antdId` prop
 **/
export default function Icon(_a) {
    var { id, className = "", alt } = _a, props = __rest(_a, ["id", "className", "alt"]);
    if (!id) {
        throw new Error(`Property "id" is required`);
    }
    const isAntdIcon = useMemo(() => AntdIcons.includes(id), [id]);
    // const [LazyIconComponent, setLazyIconComponent] =
    //   useState<LazyExoticComponent<ComponentType>>();
    // // Fetch Lazy Icon
    // useEffect(() => {
    //   try {
    //     let LazyIcon;
    //     if(!isAntdIcon){
    //       LazyIcon = lazy(
    //         () =>
    //           import(
    //             `./Icons/${id}${
    //               process.env.NODE_ENV === "development" ? ".tsx" : ".js"
    //             }`
    //           )
    //       );
    //     }else{
    //      LazyIcon = lazy(
    //         () =>
    //           import(
    //             `@ant-design/icons/lib/icons/${id}${
    //               process.env.NODE_ENV === "development" ? ".tsx" : ".js"
    //             }`
    //           )
    //       );
    //      }
    //
    //     setLazyIconComponent(LazyIcon);
    //   } catch {
    //     throw new Error(`Unable to load Icon ${id}, are you sure its valid?`);
    //   }
    // }, [id]);
    // The antdIcon already comes wrapped with a aria wrapper span, so we don't need to wrap it.
    const IconComponent = Icons[id];
    const Icon = isAntdIcon ? (_jsx(IconComponent, { "aria-label": alt })) : (_jsx(IconWrapper, { "aria-label": alt, component: () => _jsx(IconComponent, {}) }));
    return (_jsx("div", Object.assign({ className: `
        te-icon
        te-inline-block te-box-content
        ${className}
      ` }, props, { children: Icon })));
}
